export default {
    path: '/',
    meta: {
        title: '圆租',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/`),
}


// WEBPACK FOOTER //
// ./src/views/HomePage/router.js